/**
 * Labstep
 *
 * @module core/Action/Copy
 * @desc Action to copy text in clipboard
 */

import copy from 'copy-to-clipboard';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { addActionComponentPropsToDefault } from 'labstep-web/core/Action/Component/utils';
import type React from 'react';
import { useState } from 'react';
import type { IActionCopyProps } from './types';

export const COPIED_ALERT = 'Copied!';

export const ActionCopy: React.FC<IActionCopyProps> = ({
  text,
  hoverContent = 'Click to copy',
  actionComponentProps: extraActionComponentProps,
}) => {
  const [content, setContent] = useState(hoverContent);

  let actionComponentProps = {
    type: 'option',
    elementProps: {
      popup: {
        content,
        on: content === COPIED_ALERT ? 'click' : 'hover',
        onClose: () => {
          setContent(hoverContent);
        },
        hideOnScroll: true,
      },
    },
  } as ActionComponentProps;

  actionComponentProps = addActionComponentPropsToDefault(
    actionComponentProps,
    extraActionComponentProps,
  );

  return (
    <ActionComponent
      dataCy="core/Action/Copy"
      data-private
      onClick={(): void => {
        setContent(COPIED_ALERT);
        copy(text);
      }}
      {...actionComponentProps}
    />
  );
};
